// CRM per-user permission helper — frontend mirror of backend
// crm/utils/permissions.js (Batch 1, item A.5).
//
// The backend is the real enforcer (403 on every gated route). This only
// decides which buttons to render, so a stale copy can never grant access —
// it can only hide a button the server would have refused anyway.
//
// Admins implicitly have ALL permissions. A non-admin has a permission only if
// it is in their crm_permissions array (from /auth/me).

export const CRM_PERMISSIONS = [
  'open_opportunity',
  'manage_transfers',
  'assign_opportunity',
  'revert_stage'
];

export const PERM_LABEL = {
  open_opportunity: 'فتح فرصة',
  manage_transfers: 'إدارة التحويلات',
  assign_opportunity: 'إسناد الطلبات',
  revert_stage: 'إرجاع المراحل'
};

export const hasPerm = (user, perm) => {
  if (!user) return false;
  if (user.role === 'admin') return true;
  const list = Array.isArray(user.crmPermissions) ? user.crmPermissions : [];
  return list.includes(perm);
};
